import React from 'react';
import SoqlBotResponseLoader from '../utils/spinners/SoqlBotResponseLoader';
import LoadingSpinner from '../utils/spinners/LoadingSpinner';
import Response from './Response';
import { RenderMode } from '../../types';
const Messages = ({ mode, renderMode, messages, statusMessage, messageRef }) => {
    var _a, _b;
    const renderSpinner = () => {
        switch (renderMode) {
            case RenderMode.FLOATING:
                return React.createElement(SoqlBotResponseLoader, { statusMessage: statusMessage });
            default:
                return (React.createElement("div", { className: "ai-response-spinner default-spinner" },
                    React.createElement(LoadingSpinner, { statusMessage: statusMessage })));
        }
    };
    const lastIncompleteIndex = (_b = (_a = messages
        .map((msg, idx) => ({ msg, idx }))
        .reverse()
        .find(({ msg }) => !msg.isResponseCompleted)) === null || _a === void 0 ? void 0 : _a.idx) !== null && _b !== void 0 ? _b : -1;
    return (React.createElement(React.Fragment, null,
        messages.map((message, index) => (React.createElement("div", { key: index },
            React.createElement("div", { className: "aiResponse" },
                React.createElement("div", { className: "ai-response-layout" },
                    message.question && (React.createElement("div", { className: "ai-request" },
                        React.createElement("p", { className: "userText", "data-text": "text" }, message.question))),
                    message.isResponseCompleted ? (React.createElement(Response, { message: message, mode: mode, renderMode: renderMode })) : index === lastIncompleteIndex ? (renderSpinner()) : null))))),
        React.createElement("div", { ref: messageRef })));
};
export default Messages;
//# sourceMappingURL=Messages.js.map